import { type Atlas, StaticAtlasEntryType, type TileAtlasEntry } from '@/atlas';
import { Font, FontCharacter } from './base';

export class Sans11Font extends Font {
  getFrame(): TileAtlasEntry | undefined {
    return this.atlas.getStaticEntry(StaticAtlasEntryType.Sans11);
  }

  constructor(atlas: Atlas) {
    super(atlas);
    this.characters = [
      new FontCharacter(0x20, 1, 1, 3, 9),
      new FontCharacter(0x21, 14, 1, 3, 9),
      new FontCharacter(0x22, 27, 1, 5, 9),
      new FontCharacter(0x23, 40, 1, 7, 9),
      new FontCharacter(0x24, 53, 1, 6, 10),
      new FontCharacter(0x25, 66, 1, 8, 9),
      new FontCharacter(0x26, 79, 1, 6, 9),
      new FontCharacter(0x27, 92, 1, 2, 9),
      new FontCharacter(0x28, 105, 1, 3, 11),
      new FontCharacter(0x29, 118, 1, 3, 11),
      new FontCharacter(0x2a, 131, 1, 4, 9),
      new FontCharacter(0x2b, 144, 1, 6, 9),
      new FontCharacter(0x2c, 157, 1, 3, 10),
      new FontCharacter(0x2d, 170, 1, 3, 9),
      new FontCharacter(0x2e, 183, 1, 3, 9),
      new FontCharacter(0x2f, 196, 1, 5, 9),
      new FontCharacter(0x30, 1, 14, 6, 9),
      new FontCharacter(0x31, 14, 14, 6, 9),
      new FontCharacter(0x32, 27, 14, 6, 9),
      new FontCharacter(0x33, 40, 14, 6, 9),
      new FontCharacter(0x34, 53, 14, 6, 9),
      new FontCharacter(0x35, 66, 14, 6, 9),
      new FontCharacter(0x36, 79, 14, 6, 9),
      new FontCharacter(0x37, 92, 14, 6, 9),
      new FontCharacter(0x38, 105, 14, 6, 9),
      new FontCharacter(0x39, 118, 14, 6, 9),
      new FontCharacter(0x3a, 131, 14, 3, 9),
      new FontCharacter(0x3b, 144, 14, 3, 10),
      new FontCharacter(0x3c, 157, 14, 6, 9),
      new FontCharacter(0x3d, 170, 14, 6, 9),
      new FontCharacter(0x3e, 183, 14, 6, 9),
      new FontCharacter(0x3f, 196, 14, 6, 9),
      new FontCharacter(0x40, 1, 27, 11, 10),
      new FontCharacter(0x41, 14, 27, 7, 9),
      new FontCharacter(0x42, 27, 27, 7, 9),
      new FontCharacter(0x43, 40, 27, 7, 9),
      new FontCharacter(0x44, 53, 27, 8, 9),
      new FontCharacter(0x45, 66, 27, 7, 9),
      new FontCharacter(0x46, 79, 27, 6, 9),
      new FontCharacter(0x47, 92, 27, 8, 9),
      new FontCharacter(0x48, 105, 27, 8, 9),
      new FontCharacter(0x49, 118, 27, 3, 9),
      new FontCharacter(0x4a, 131, 27, 5, 9),
      new FontCharacter(0x4b, 144, 27, 7, 9),
      new FontCharacter(0x4c, 157, 27, 6, 9),
      new FontCharacter(0x4d, 170, 27, 9, 9),
      new FontCharacter(0x4e, 183, 27, 8, 9),
      new FontCharacter(0x4f, 196, 27, 8, 9),
      new FontCharacter(0x50, 1, 40, 7, 9),
      new FontCharacter(0x51, 14, 40, 8, 10),
      new FontCharacter(0x52, 27, 40, 8, 9),
      new FontCharacter(0x53, 40, 40, 7, 9),
      new FontCharacter(0x54, 53, 40, 7, 9),
      new FontCharacter(0x55, 66, 40, 8, 9),
      new FontCharacter(0x56, 79, 40, 7, 9),
      new FontCharacter(0x57, 92, 40, 11, 9),
      new FontCharacter(0x58, 105, 40, 7, 9),
      new FontCharacter(0x59, 118, 40, 7, 9),
      new FontCharacter(0x5a, 131, 40, 7, 9),
      new FontCharacter(0x5b, 144, 40, 3, 11),
      new FontCharacter(0x5c, 157, 40, 5, 9),
      new FontCharacter(0x5d, 170, 40, 3, 11),
      new FontCharacter(0x5e, 183, 40, 6, 9),
      new FontCharacter(0x5f, 196, 40, 6, 10),
      new FontCharacter(0x60, 1, 53, 3, 9),
      new FontCharacter(0x61, 14, 53, 6, 9),
      new FontCharacter(0x62, 27, 53, 6, 9),
      new FontCharacter(0x63, 40, 53, 6, 9),
      new FontCharacter(0x64, 53, 53, 6, 9),
      new FontCharacter(0x65, 66, 53, 6, 9),
      new FontCharacter(0x66, 79, 53, 3, 9),
      new FontCharacter(0x67, 92, 53, 6, 11),
      new FontCharacter(0x68, 105, 53, 6, 9),
      new FontCharacter(0x69, 118, 53, 2, 9),
      new FontCharacter(0x6a, 131, 53, 2, 11),
      new FontCharacter(0x6b, 144, 53, 6, 9),
      new FontCharacter(0x6c, 157, 53, 2, 9),
      new FontCharacter(0x6d, 170, 53, 8, 9),
      new FontCharacter(0x6e, 183, 53, 6, 9),
      new FontCharacter(0x6f, 196, 53, 6, 9),
      new FontCharacter(0x70, 1, 66, 6, 11),
      new FontCharacter(0x71, 14, 66, 6, 11),
      new FontCharacter(0x72, 27, 66, 3, 9),
      new FontCharacter(0x73, 40, 66, 5, 9),
      new FontCharacter(0x74, 53, 66, 3, 9),
      new FontCharacter(0x75, 66, 66, 6, 9),
      new FontCharacter(0x76, 79, 66, 6, 9),
      new FontCharacter(0x77, 92, 66, 8, 9),
      new FontCharacter(0x78, 105, 66, 5, 9),
      new FontCharacter(0x79, 118, 66, 5, 11),
      new FontCharacter(0x7a, 131, 66, 5, 9),
      new FontCharacter(0x7b, 144, 66, 4, 10),
      new FontCharacter(0x7c, 157, 66, 2, 10),
      new FontCharacter(0x7d, 170, 66, 4, 10),
      new FontCharacter(0x7e, 183, 66, 7, 9),
      new FontCharacter(0x7f, 196, 66, 3, 10),
      new FontCharacter(0x80, 1, 79, 6, 9),
      new FontCharacter(0x81, 14, 79, 4, 9),
      new FontCharacter(0x82, 27, 79, 3, 10),
      new FontCharacter(0x83, 40, 79, 6, 11),
      new FontCharacter(0x84, 53, 79, 4, 9),
      new FontCharacter(0x85, 66, 79, 6, 9),
      new FontCharacter(0x86, 79, 79, 5, 9),
      new FontCharacter(0x87, 92, 79, 5, 9),
      new FontCharacter(0x88, 105, 79, 4, 9),
      new FontCharacter(0x89, 118, 79, 11, 9),
      new FontCharacter(0x8a, 131, 79, 7, 9),
      new FontCharacter(0x8b, 144, 79, 6, 9),
      new FontCharacter(0x8c, 157, 79, 11, 9),
      new FontCharacter(0x8d, 170, 79, 4, 9),
      new FontCharacter(0x8e, 183, 79, 7, 9),
      new FontCharacter(0x8f, 196, 79, 4, 9),
      new FontCharacter(0x90, 1, 92, 4, 9),
      new FontCharacter(0x91, 14, 92, 3, 9),
      new FontCharacter(0x92, 27, 92, 3, 9),
      new FontCharacter(0x93, 40, 92, 4, 9),
      new FontCharacter(0x94, 53, 92, 4, 9),
      new FontCharacter(0x95, 66, 92, 6, 9),
      new FontCharacter(0x96, 79, 92, 5, 9),
      new FontCharacter(0x97, 92, 92, 7, 9),
      new FontCharacter(0x98, 105, 92, 4, 9),
      new FontCharacter(0x99, 118, 92, 9, 9),
      new FontCharacter(0x9a, 131, 92, 5, 9),
      new FontCharacter(0x9b, 144, 92, 6, 9),
      new FontCharacter(0x9c, 157, 92, 10, 9),
      new FontCharacter(0x9d, 170, 92, 4, 9),
      new FontCharacter(0x9e, 183, 92, 5, 9),
      new FontCharacter(0x9f, 196, 92, 7, 9),
      new FontCharacter(0xa0, 1, 105, 3, 9),
      new FontCharacter(0xa1, 14, 105, 3, 11),
      new FontCharacter(0xa2, 27, 105, 6, 10),
      new FontCharacter(0xa3, 40, 105, 6, 9),
      new FontCharacter(0xa4, 53, 105, 6, 9),
      new FontCharacter(0xa5, 66, 105, 6, 9),
      new FontCharacter(0xa6, 79, 105, 2, 11),
      new FontCharacter(0xa7, 92, 105, 6, 10),
      new FontCharacter(0xa8, 105, 105, 3, 9),
      new FontCharacter(0xa9, 118, 105, 9, 9),
      new FontCharacter(0xaa, 131, 105, 4, 9),
      new FontCharacter(0xab, 144, 105, 6, 9),
      new FontCharacter(0xac, 157, 105, 6, 9),
      new FontCharacter(0xad, 170, 105, 1, 9),
      new FontCharacter(0xae, 183, 105, 9, 9),
      new FontCharacter(0xaf, 196, 105, 6, 9),
      new FontCharacter(0xb0, 1, 118, 4, 9),
      new FontCharacter(0xb1, 14, 118, 6, 9),
      new FontCharacter(0xb2, 27, 118, 3, 9),
      new FontCharacter(0xb3, 40, 118, 3, 9),
      new FontCharacter(0xb4, 53, 118, 3, 9),
      new FontCharacter(0xb5, 66, 118, 6, 10),
      new FontCharacter(0xb6, 79, 118, 6, 10),
      new FontCharacter(0xb7, 92, 118, 3, 9),
      new FontCharacter(0xb8, 105, 118, 3, 11),
      new FontCharacter(0xb9, 118, 118, 3, 9),
      new FontCharacter(0xba, 131, 118, 4, 9),
      new FontCharacter(0xbb, 144, 118, 6, 9),
      new FontCharacter(0xbc, 157, 118, 8, 9),
      new FontCharacter(0xbd, 170, 118, 8, 9),
      new FontCharacter(0xbe, 183, 118, 8, 9),
      new FontCharacter(0xbf, 196, 118, 6, 11),
      new FontCharacter(0xc0, 1, 131, 7, 9),
      new FontCharacter(0xc1, 14, 131, 7, 9),
      new FontCharacter(0xc2, 27, 131, 7, 9),
      new FontCharacter(0xc3, 40, 131, 7, 9),
      new FontCharacter(0xc4, 53, 131, 7, 9),
      new FontCharacter(0xc5, 66, 131, 7, 9),
      new FontCharacter(0xc6, 79, 131, 11, 9),
      new FontCharacter(0xc7, 92, 131, 8, 11),
      new FontCharacter(0xc8, 105, 131, 7, 9),
      new FontCharacter(0xc9, 118, 131, 7, 9),
      new FontCharacter(0xca, 131, 131, 7, 9),
      new FontCharacter(0xcb, 144, 131, 7, 9),
      new FontCharacter(0xcc, 157, 131, 3, 9),
      new FontCharacter(0xcd, 170, 131, 3, 9),
      new FontCharacter(0xce, 183, 131, 3, 9),
      new FontCharacter(0xcf, 196, 131, 3, 9),
      new FontCharacter(0xd0, 1, 144, 8, 9),
      new FontCharacter(0xd1, 14, 144, 8, 9),
      new FontCharacter(0xd2, 27, 144, 8, 9),
      new FontCharacter(0xd3, 40, 144, 8, 9),
      new FontCharacter(0xd4, 53, 144, 8, 9),
      new FontCharacter(0xd5, 66, 144, 8, 9),
      new FontCharacter(0xd6, 79, 144, 8, 9),
      new FontCharacter(0xd7, 92, 144, 6, 9),
      new FontCharacter(0xd8, 105, 144, 8, 9),
      new FontCharacter(0xd9, 118, 144, 8, 9),
      new FontCharacter(0xda, 131, 144, 8, 9),
      new FontCharacter(0xdb, 144, 144, 8, 9),
      new FontCharacter(0xdc, 157, 144, 8, 9),
      new FontCharacter(0xdd, 170, 144, 7, 9),
      new FontCharacter(0xde, 183, 144, 7, 9),
      new FontCharacter(0xdf, 196, 144, 7, 9),
      new FontCharacter(0xe0, 1, 157, 6, 9),
      new FontCharacter(0xe1, 14, 157, 6, 9),
      new FontCharacter(0xe2, 27, 157, 6, 9),
      new FontCharacter(0xe3, 40, 157, 6, 9),
      new FontCharacter(0xe4, 53, 157, 6, 9),
      new FontCharacter(0xe5, 66, 157, 6, 9),
      new FontCharacter(0xe6, 79, 157, 10, 9),
      new FontCharacter(0xe7, 92, 157, 6, 11),
      new FontCharacter(0xe8, 105, 157, 6, 9),
      new FontCharacter(0xe9, 118, 157, 6, 9),
      new FontCharacter(0xea, 131, 157, 6, 9),
      new FontCharacter(0xeb, 144, 157, 6, 9),
      new FontCharacter(0xec, 157, 157, 2, 9),
      new FontCharacter(0xed, 170, 157, 3, 9),
      new FontCharacter(0xee, 183, 157, 4, 9),
      new FontCharacter(0xef, 196, 157, 4, 9),
      new FontCharacter(0xf0, 1, 170, 6, 9),
      new FontCharacter(0xf1, 14, 170, 6, 9),
      new FontCharacter(0xf2, 27, 170, 6, 9),
      new FontCharacter(0xf3, 40, 170, 6, 9),
      new FontCharacter(0xf4, 53, 170, 6, 9),
      new FontCharacter(0xf5, 66, 170, 6, 9),
      new FontCharacter(0xf6, 79, 170, 6, 9),
      new FontCharacter(0xf7, 92, 170, 6, 9),
      new FontCharacter(0xf8, 105, 170, 6, 9),
      new FontCharacter(0xf9, 118, 170, 6, 9),
      new FontCharacter(0xfa, 131, 170, 6, 9),
      new FontCharacter(0xfb, 144, 170, 6, 9),
      new FontCharacter(0xfc, 157, 170, 6, 9),
      new FontCharacter(0xfd, 170, 170, 5, 11),
      new FontCharacter(0xfe, 183, 170, 6, 11),
      new FontCharacter(0xff, 196, 170, 5, 11),
    ];
  }
}
